import { getEnv } from '@/env'
import type { KsecMeProduct } from './types'

/**
 * Modo degradado cuando KSEC no está disponible.
 *
 * KSEC se considera habilitado SOLO si IT_MFE_KSEC_ENABLE vale 'true' o '1'.
 * Con 'false', vacío o sin definir, el bootstrap no llama a KSEC y el portal
 * muestra el producto Recaudos por defecto (ver FALLBACK_RECAUDOS_PRODUCT).
 *
 * Se acepta también la clave cruda `ksec_enable` por compatibilidad.
 */
export function isKsecEnabled(): boolean {
  const raw = (getEnv('IT_MFE_KSEC_ENABLE') || getEnv('ksec_enable')).trim().toLowerCase()
  return raw === 'true' || raw === '1'
}

/**
 * Producto mostrado cuando KSEC está deshabilitado.
 *
 * portal_url sale de IT_MFE_KSEC_FALLBACK_URL, que debe terminar en el
 * parámetro del token (…?token=): ProductoCard le concatena el id_token de
 * Auth0 para armar el deep-link de SSO.
 * userRoles queda vacío: sin KSEC no se puede conocer el rol real del usuario.
 */
export const FALLBACK_RECAUDOS_PRODUCT: KsecMeProduct = {
  assetId:       'fallback-recaudos',
  name:          'Recaudos',
  type:          1,  // WEB_APPLICATION
  userRoles:     [],
  portal_url:    getEnv('IT_MFE_KSEC_FALLBACK_URL'),
  offering_name: 'RECAUDOS',
  offering_id:   null,
}
